<template>
	<div>
		<el-menu class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b"
			:collapse="isCollapse">
			<template v-for="item in asideMenus">
				<el-submenu :index="item.name" v-if="!!item.children && !!item.children.length" :key="item.name">
					<template slot="title">
						<i class="el-icon-menu"></i>
						<span>{{ item.meta.title }}</span>
					</template>
					<el-menu-item v-for="temp in item.children" v-if="item.meta.isMenu" :index="temp.path" @click="openPage(item)"
						:key="temp.path">{{ temp.meta.title }}</el-menu-item>
				</el-submenu>
				<template v-else>
					<!-- 
					008005008/入库异常登记
					008006013/小件单品批量打包
					-->
					<el-menu-item :index="item.path" :key="item.name" @click="openPage(item)" v-if="
						!item.hidden &&
						(item.id === '008005008' ? isHzOrXz : item.id === '008006013' ? isHzOrXzOrGz : true)
					">
						<i class="el-icon-menu"></i>
						<span slot="title">{{ item.meta.title }}</span>
					</el-menu-item>
				</template>
			</template>
		</el-menu>
	</div>
</template>

<script>
import store from "@/store";
export default {
	name: "AsideNav",
	props: {
		isCollapse: Boolean,
	},
	computed: {
		asideMenus: function () {
			// console.log('-------------',store.getters.getMenus)
			if (!store.getters.getMenus) {
				return false;
			}
			const _asideMenus =
				store.getters.getMenus &&
				store.getters.getMenus.reduce((pre, item) => {
					if (item.isActive) {
						pre = item;
					}
					return pre;
				}, {});
			return _asideMenus.children;
		},
		isHzOrXz: function () {
			const name = this.$store.getters.getWarehouses?.filter(
				(item) => item.wareCode == this.$store.getters.getWareCode
			)[0].wareName;
			return name === "杭州仓"
		},
		isHzOrXzOrGz: function () {
			const name = this.$store.getters.getWarehouses?.filter(
				(item) => item.wareCode == this.$store.getters.getWareCode
			)[0].wareName;
			return name === "杭州仓" || name === "西子仓" || name === "广州仓";
		},
	},
	methods: {
		openPage: function (item) {
			this.$router.push(item.path);
		},
	},
};
</script>

<style scoped lang="stylus">
.el-menu-vertical-demo:not(.el-menu--collapse) {
	width: 200px;
}

.el-menu-vertical-demo {
	height: calc(100vh - 60px);
}

::v-deep .el-menu-item, ::v-deep .el-submenu__title {
	text-align: left !important;
}
</style>